<template>
  <div
    class="header-body"
    :style="
      `background-image:url(${banner}); background-repeat: no-repeat; background-size: cover`
    "
  >
    <div class="header-body__logo">
      <img
        :src="logo"
        alt
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    unionHead: {
      type: Object,
      default: () => null,
    },
  },
  computed: {
    logo() {
      const { shopLogo } = this.unionHead;
      return shopLogo;
    },
    banner() {
      const { shopTopPic } = this.unionHead;
      return shopTopPic;
    },
  },
};
</script>

<style lang="less" scoped>
.header-body {
  .wrapper();
  margin-top: -28px;
  &__logo {
    display: table-cell;
    vertical-align: middle;
    height: 130px;
    > img {
      height: 100px;
    }
  }
}
</style>
